import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FilterStringService {


  /**
   * Filters integer
   *
   * @param {string} searchValue Value to search
   * @param {string} str Value to compare
   * @returns {boolean} true if matched
   */
  filterInteger(searchValue, str) {
    let matched = true
    matched = this.filterString(searchValue + '', str + '')
    return matched
  }


   /**
   * Filters string
   *
   * @param {string} searchValue Value to search
   * @param {string} str Value to compare
   * @returns {boolean} true if matched
   */
  filterString(searchValue: any, str: any) {
    let matched = true
    let searchLowerCase = searchValue.toLowerCase()
    let searchContent = searchValue.slice(1)
    let searchContentLowerCase = searchLowerCase.slice(1)
    switch (searchValue.charAt(0)) {
      case '/':
        let lastSlash = searchContent.lastIndexOf('/')
        if (lastSlash !== -1) {
          let pattern = searchContent.substring(0, lastSlash)
          let flags = searchContent.substring(lastSlash + 1)
          let regex = new RegExp(pattern, flags)
          matched = !_.isNull(str.match(regex))
        } else {
          matched = true // Regex is not complete, don't filter yet
        }
        break
      case '!':
        matched = str.toLowerCase().indexOf(searchContentLowerCase) === -1
        break
      default:
        matched = str.toLowerCase().indexOf(searchLowerCase) !== -1
    }
    return matched
  }
}
